// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1TWjk","header":"ClearentDisclaimer_header__1PQH8","inner":"ClearentDisclaimer_inner__2JmxB"};